/* globals gtag: true */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Route, Switch } from "react-router";
import { createAppContainer } from "@folklore/react-app";

import reducers, { history } from "../reducers/index";
import MainLayout from "./layouts/Main";
import PagesComponents from "./pages/index";
import Page from "./pages/Page";
import Post from "./pages/Post";
import Production from "./pages/Production";

import "../../styles/main.global.scss";

const normalize = (str) => str.replace(/[^A-Za-z0-9]/gi, "").toLowerCase();

const propTypes = {
    pages: PropTypes.arrayOf(
        PropTypes.shape({
            type: PropTypes.string,
            url: PropTypes.string,
        })
    ),
    urlGenerator: PropTypes.shape({
        route: PropTypes.func,
    }).isRequired,
    history: PropTypes.shape({
        listen: PropTypes.func,
    }).isRequired,
    googleAnalyticsId: PropTypes.string,
};

const defaultProps = {
    pages: [],
    googleAnalyticsId: null,
};

class App extends Component {
    constructor(props) {
        super(props);

        this.onHistoryChange = this.onHistoryChange.bind(this);
        this.historyUnlisten = null;
    }

    componentDidMount() {
        const { history } = this.props;
        this.historyUnlisten = history.listen(this.onHistoryChange);
    }

    componentWillUnmount() {
        if (this.historyUnlisten !== null) {
            this.historyUnlisten();
        }
    }

    // eslint-disable-next-line class-methods-use-this
    onHistoryChange(location) {
        const { googleAnalyticsId } = this.props;
        if (googleAnalyticsId !== null && typeof gtag !== "undefined") {
            const url = `${location.pathname}${location.search}`;
            setTimeout(() => {
                gtag("config", googleAnalyticsId, {
                    page_path: url,
                    page_title: document.title,
                });
            }, 10);
        }
    }

    render() {
        const { pages, urlGenerator } = this.props;

        return (
            <MainLayout>
                <Switch>
                    <Route exact path={urlGenerator.route("news.show")} component={Post} />
                    <Route
                        exact
                        path={urlGenerator.route("productions.show")}
                        component={Production}
                    />
                    {pages.map(({ type, url }) => (
                        <Route
                            key={`page-${url}`}
                            exact
                            path={url}
                            component={
                                PagesComponents[
                                    Object.keys(PagesComponents).find(
                                        (name) => normalize(name) === normalize(type)
                                    ) || "Page"
                                ] || Page
                            }
                        />
                    ))}
                </Switch>
            </MainLayout>
        );
    }
}

App.propTypes = propTypes;
App.defaultProps = defaultProps;

// Create container
const containerPropTypes = {
    locale: PropTypes.string,
    messages: PropTypes.oneOfType([
        PropTypes.objectOf(PropTypes.objectOf(PropTypes.string)),
        PropTypes.objectOf(PropTypes.string),
    ]).isRequired,
    pages: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            type: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
            handle: PropTypes.string,
            data: PropTypes.object.isRequired,
        })
    ),
    page: PropTypes.shape({
        id: PropTypes.number.isRequired,
        type: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        handle: PropTypes.string,
        data: PropTypes.object.isRequired,
    }),
    position: PropTypes.shape({
        latitude: PropTypes.number.isRequired,
        longitude: PropTypes.number.isRequired,
    }).isRequired,
    googleApiKey: PropTypes.string.isRequired,
    headerMenuItems: PropTypes.arrayOf(PropTypes.object).isRequired,
    productionsCategories: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const containerDefaultProps = {
    locale: "fr",
    page: null,
};

const getStoreReducers = () => reducers;

// Get store initial state from props
const getStoreInitialState = ({
    pages,
    page,
    news,
    productions,
    headerMenuItems,
    footerMenuItems,
    productionsCategories,
    position,
    googleApiKey,
}) => ({
    site: {
        pages,
        page,
        news,
        productions,
        position,
        headerMenuItems,
        footerMenuItems,
        productionsCategories,
        googleApiKey,
    },
});

const AppContainer = createAppContainer({
    propTypes: containerPropTypes,
    defaultProps: containerDefaultProps,
    getStoreReducers,
    getStoreInitialState,
    createHistory: () => history,
})(App);

export default AppContainer;



// WEBPACK FOOTER //
// ./js/components/App.jsx